import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CoursesAssignments from './pages/CourseAssignments';
import UserDashboard from './pages/UserDashboard';
import { getLMSRoutes } from './pages/LMS.constants';
import CreateAssignment from './pages/CreateAssignment';
import useLMSDashboard from './hooks/useLMSDashboard';

const LearningManager: React.FC = () => {
	const lmsRoutes = getLMSRoutes();
	const { path } = useRouteMatch();
	const { isAdminView } = useLMSDashboard();

	const Dashboard = isAdminView ? CoursesAssignments : UserDashboard;

	return (
		<Switch>
			<Route exact path={path} component={Dashboard} />
			<Route
				exact
				path={`${path}${lmsRoutes.createAssignment}`}
				component={CreateAssignment}
			/>
		</Switch>
	);
};

export default LearningManager;
